import type { AxiosInstance } from 'axios';
import { setupAxios } from '@tempus/t-shared/ui';

const [client, impersonatedIds] = setupAxios('t-impersonate-institutions', true);

export { impersonatedIds };

// axios 1.20.0 added a params generic on AxiosInstance.request; axios-cache-interceptor
// 1.12.x types (via t-shared setupAxios) are not assignable without a cast.
export default client as unknown as AxiosInstance;
